<template>
    <div class="statistic-list-wrap">
        <div class="tournament-title"><p>{{tournament.tnmtName}}</p></div>

        <div class="table-wrap" ref="participantList" :scroll="handleScroll">
            <EmptyContent v-if="!statistics || statistics.statisticList.length <=0" content="검색결과가 없습니다" style="height: 100%"></EmptyContent>
            <table v-else>
                <tr>
                    <th class="vertical-scroll-fix rank"><p class="rank">순위</p></th>
                    <th class="vertical-scroll-fix team-name"><p class="team-name">소속명</p></th>
                    <th class="vertical-scroll-fix score" style="border-right: 1px solid #969696;"><p class="score">총점</p></th>
                    <th>입장점수</th>
                    <th>1위</th>
                    <th >2위</th>
                    <th>3위</th>
                    <th>패널티 점수(감점)</th>
                    <th>참가점수</th>
                </tr>
                <tr v-for="(statistic, statisticIndex) in statistics.statisticList" :key="`statistic${statisticIndex}`">
                    <td class="vertical-scroll-fix rank"><p class="rank">{{statistic.rank}}</p></td>
                    <td class="vertical-scroll-fix team-name"><p class="team-name">{{statistic.teamName}}</p></td>
                    <td class="vertical-scroll-fix score" style="border-right: 1px solid #969696;"><p class="score">{{statistic.teamTotalPoin}}</p></td>
                    <td>{{statistic.admissionPoint}}</td>
                    <td>{{statistic.firstRankPoin}}</td>
                    <td>{{statistic.secondRankPoin}}</td>
                    <td>{{statistic.thirdRankPoin}}</td>
                    <td>{{statistic.penaltyPoint}}</td>
                    <td>{{statistic.teamParticipantPoint}}</td>

                </tr>
            </table>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import EmptyContent from "../../common/EmptyContent";
    export default{
        components: {EmptyContent},
        computed: {
            ...mapState('tournaments', ['tournament', 'statistics'])
        },
        created() {
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll(event){
                const scrollTop = event.target.scrollTop
                localStorage.setItem('TournamentStatisticList', scrollTop)
            },
        },
        mounted() {
            if(localStorage.getItem('TournamentStatisticList')){
                this.$refs.participantList.scrollTop = localStorage.getItem('TournamentStatisticList')
            }
        }
    }
</script>
